import { axios } from "@/plugins/http-request.js";

const state = {};

const getters = {};

const actions = {
  getomsCategoryList(context, payload) {
    return axios
      .get("/api/fulfillment/sku_category", {
        params: payload,
      })
      .then((res) => res.data);
  },
  syncOmsScreen() {
    return axios
      .get("/api/fulfillment/sku_category_sync")
      .then((res) => res.data);
  },
  syncInventory(_, id) {
    if (id == undefined) {
      return axios
        .get(`/api/fulfillment/inventory_snapshot_sync`)
        .then((res) => res.data);
    } else {
      return axios
        .get(`/api/fulfillment/inventory_snapshot_sync?client_id=${id}`)
        .then((res) => res.data);
    }
  },
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations,
};
